import { render } from "./CapitalDetail.vue?vue&type=template&id=46f466c4&scoped=true"
import script from "./CapitalDetail.vue?vue&type=script&lang=js"
export * from "./CapitalDetail.vue?vue&type=script&lang=js"

import "./CapitalDetail.vue?vue&type=style&index=0&id=46f466c4&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f466c4"]])

export default __exports__